import React, { useState, useEffect, useContext  } from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {API_URL,FAST_API_URL} from "../api"


const SubscriptionSelector = ({setIsPaid}) => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

useEffect(() => {

  const checkSubscription = async () => {

    const token = localStorage.getItem("token");

    try {

      // =====================================
      // CHECK PAID SUBSCRIPTION
      // =====================================

      const response = await axios.post(
        `${API_URL}/check_view`,
        {
          patient_id: localStorage.getItem("patient_id"),
        }
      );

      console.log("Check view response:", response.data);

      // =====================================
      // USER ALREADY PAID
      // =====================================

      if (response.status === 200) {

        setIsPaid(true);

        navigate("/purpose");

        return;

      }

    } catch (err) {

      console.log(err.response, "CHECK VIEW ERROR");

      // =====================================
      // IF PAYMENT NOT FOUND
      // =====================================

      if (err.response?.status === 400) {

        try {

          // =====================================
          // CHECK FREE TRIAL PLAN
          // =====================================

          const planResponse = await axios.post(
            `${API_URL}/check-patient-plan`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          console.log(planResponse.data, "PLAN RESPONSE");

          // =====================================
          // FREE TRIAL ACTIVE
          // =====================================

          if (planResponse.data.status_code === 200) {

            setIsPaid(true);

            navigate("/purpose");

          }

          // =====================================
          // PAYMENT REQUIRED
          // =====================================

          else {

            setIsPaid(false);

            navigate("/subscription");

          }

        } catch (planError) {

          console.log(planError.response, "PLAN ERROR");

          setIsPaid(false);

          navigate("/subscription");

        }

      } else {

        setIsPaid(false);

        navigate("/subscription");

      }

    }

  };

  checkSubscription();

}, [navigate]);

  const handleSelect = async (subscription_type) => {
    console.log(subscription_type, "subscription_type")
    try {
      const response = await axios.post(`${API_URL}/subscription_type`, {
        subscription_type,
        patient_id: localStorage.getItem("patient_id"),
      });
      console.log(response.data?.success)
      if (response.status===200) {
        navigate("/coupon")
        console.log("Subscription updated successfully:", response.data);
        // Optionally show a success toast or navigate to another page
      } else {
        console.warn("Subscription update failed:", response.data);
      }
    } catch (error) {
      console.error("Error updating subscription:", error);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center bg-gradient-to-br from-teal-400 via-green-300 to-blue-200 p-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-xl bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 space-y-6"
      >
        <h2 className="text-3xl font-bold text-center text-gray-800">
          🩺 Choose a Subscription Plan
        </h2>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          {["Monthly", "Yearly"].map((plan) => {
            const lowerPlan = plan;
            const price = plan === "Monthly";

            return (
              <motion.div
                key={plan}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleSelect(lowerPlan)}
                className={`w-full sm:w-1/2 cur qsor-pointer border-2 rounded-xl p-6 text-center transition-all duration-300 ${
                  selected === lowerPlan
                    ? "border-teal-600 bg-teal-50 shadow-lg"
                    : "border-gray-300 bg-white"
                }`}
              >
                <div className="text-xl font-semibold text-gray-700">{plan} Plan</div>
                <div className="text-sm text-gray-500 mt-1">{price}</div>
                {selected === lowerPlan && (
                  <div className="mt-3 text-teal-600 flex justify-center items-center gap-1">
                    <CheckCircle size={18} /> Selected
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>

        {/* {selected && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center text-sm text-green-700 mt-4"
          >
            ✅ You’ve selected the <strong>{selected}</strong> plan.
          </motion.div>
        )} */}
      </motion.div>
    </div>
  );
};

export default SubscriptionSelector;
